'use client';

import { useMemo } from 'react';

import type { Locales } from '@personly/libs-types';
import { makeLocalizedPathname } from '@personly/libs-pathnames';

const useLocalizedPathname = (locales: Locales) => {
  const result = useMemo(() => makeLocalizedPathname(locales), [locales]);

  return result;
};

export default useLocalizedPathname;
